import angular = require("angular");
import {Type, TypeList} from "../directives/content/type";


export function typeFilter() {

  return function(typeList: TypeList, alcoholPolicy: string, dietaryRestrictions: string[]) {
    return typeList.filter((item) => {

      if (item.key == alcoholPolicy) {
        return true;
      }

      var found = false;

      angular.forEach(dietaryRestrictions, (value)=> {
        if (item.key == value) {
          found = true;
        }
      });

      return found;
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/filters/type.ts
 **/